module.exports = __webpack_public_path__ + "img/icon-wallet-disabled.7185bfbd.svg";